import { useSearchParams } from "react-router-dom"
import useLogin from "./useLogin";
import { useEffect } from "react";
import { Spinner } from "reactstrap";

const AutoLogin = () => {
    const [serachParams] = useSearchParams();
    const app_code = serachParams.get('app_code');
    const{login}=useLogin();

    useEffect(()=>{
        if(app_code){
            login(app_code)
        }
    },[app_code,login])
    return <div className="d-flex justify-content-center align-items-center"><Spinner/></div>;
}

export default AutoLogin